import React, { JSX, useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../../../../LiveLessonReseveContext';

import {
  formatTime, formatTimeAddMin,
} from '../../../../../../../../../util/utility';


function LiveReserveDateModalTime(props: any) {

  const {
    lsnMin, selectedScheduleId, setSelectedScheduleId,
  } = useContext(LiveReserveContext);

  const dateKey = props.dateKey;
  const timeKey = props.timeKey;
  const timeInfo = props.timeInfo;


  return (
    <li key={timeKey} className="list-group-item" style={{ padding: 0 }}>
      <label
        htmlFor={`c_${dateKey}${timeKey}`}
        style={{width: '100%', height: '100%', padding: '10px 15px', cursor: 'pointer'}}
      >
        {formatTime(timeKey)} 〜 {formatTimeAddMin(timeKey, lsnMin)}
        {timeKey >= '00:00:00' && timeKey < '05:00:00' && ' (深夜)'}
        {timeKey >= '05:00:00' && timeKey < '08:00:00' && ' (早朝)'}

        <span className="radio home-checkbox">
          <input
            id={`c_${dateKey}${timeKey}`}
            type="radio"
            style={{top: '-10px', right: 0, zIndex: 1,}}
            name="sche_id"
            value={timeInfo}
            checked={selectedScheduleId === timeInfo}
            onChange={() => setSelectedScheduleId(timeInfo)}
          />
        </span>
      </label>
    </li>
  );
}
  
export default LiveReserveDateModalTime;